import {Component, OnInit} from '@angular/core';
import {Global} from "../global";
import {Components} from "../shared/components/components";
import {TranslateService} from '@ngx-translate/core';
import {Router, ActivatedRoute} from "@angular/router";
import {Funcoes} from "../funcoes";
import {LoginService} from "../login/login.service";
import {ClientesService} from "../clientes/clientes.service";
import {FichasService} from "../fichas/fichas.service";
import {FichasModel} from "../fichas/fichas.model";
import {FormBuilder, FormGroup} from "@angular/forms";
import {MercadoriasService} from "../mercadorias/mercadorias.service";
import {FaturasService} from "../faturas/faturas.service";

declare var swal, $: any;

@Component({
  selector: 'app-financeiro-preliminares-cliente',
  templateUrl: './financeiro-preliminares-cliente.component.html'
})
export class FinanceiroPreliminaresClienteComponent extends Components implements OnInit {

  formPesquisaAvancada: FormGroup;
  filtroPesquisa = {"mercadoria":"", "cliente":"", "container":"", "data_de": "", "data_ate": "", "conhecimento": ""};

  fichas: FichasModel[] = [];
  privilegioUsuario = {"editar": false, "consultar": false};

  listMercadorias = [];
  listStatus = [{
    "texto": "Aguardando Revisão",
    "valor": 1
  },{
    "texto": "Online",
    "valor": 2
  }];

  listFaturada = [{
    "texto": "Sim",
    "valor": 1
  },{
    "texto": "Não",
    "valor": 0
  }];

  mascaraContainer = [/[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /[a-zA-Z]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/];
  idCliente: string;

  selecionarTodos: boolean = false;
  selecionados: any = {};

  faturar = {
    "data": ""
  };
  formFaturar: FormGroup;
  carregandoBotaoFaturar: boolean = false;

  constructor(
    formBuilder: FormBuilder,
    private fichasService: FichasService,
    private clientesService: ClientesService,
    private mercadoriasService: MercadoriasService,
    private faturasService: FaturasService,
    public global: Global,
    protected translate: TranslateService,
    protected router: Router,
    private route: ActivatedRoute,
    public func: Funcoes,
    public loginService: LoginService
  ) {
    super();

    let date = new Date().toISOString();
    this.filtroPesquisa.data_de = date.substr(0, 8)+'01';
    this.filtroPesquisa.data_ate = date.substr(0, 10);

    this.loginService.getUserInfo().subscribe(data => {
      for(let i in data.privilegios){
        if(data.privilegios[i].acao[0].url == 'financeiro'){
          this.privilegioUsuario.consultar = data.privilegios[i].consultar;
          this.privilegioUsuario.editar = data.privilegios[i].editar;
        }
      }
    });

    this.formPesquisaAvancada = formBuilder.group({
      mercadoria: [],
      container: [],
      data_de: [],
      data_ate: [],
      conhecimento: []
    });

    this.formFaturar = formBuilder.group({
      data: []
    });

    // busca mercadorias
    this.mercadoriasService.get()
      .subscribe(json => {
        this.listMercadorias = json.Payload;
      });
  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.idCliente = params['id_cliente'];
      this.filtroPesquisa.cliente = this.idCliente;

      // busca filtro salvo no localStorage (opcional para essa tela dedicada, mas mantendo a lógica se desejar)
      let filtroSalvo = this.carregaFiltro();
      if (filtroSalvo) {
        this.filtroPesquisa = filtroSalvo;
        this.filtroPesquisa.cliente = this.idCliente; // Garante que o cliente da URL prevalece
        this.formPesquisaAvancada.patchValue(filtroSalvo);
      }
      
      this.carregandoTabela = true;
      this.getPage(1);
    });
  }

  getPage(pagina){
    this.paginaAtual = pagina;
    this.carregandoTabela = true;

    let filtros = {};
    filtros['id_cliente'] = "**:"+this.idCliente;

    if (this.filtroPesquisa.data_de && this.filtroPesquisa.data_ate) {
      filtros['data_inspecao'] = 'bt:' + this.filtroPesquisa.data_de + '|' + this.filtroPesquisa.data_ate;
    } else {
      if (this.filtroPesquisa.data_de) {
        filtros['data_inspecao'] = 'ge:' + this.filtroPesquisa.data_de;
      }

      if (this.filtroPesquisa.data_ate) {
        filtros['data_inspecao'] = 'le:' + this.filtroPesquisa.data_ate;
      }
    }

    filtros['id_status'] = '2'; // Apenas Online
    filtros['faturada'] = '0'; // Apenas Não Faturadas
    if(this.filtroPesquisa.mercadoria != ''){
      filtros['id_mercadoria'] = "**:"+this.filtroPesquisa.mercadoria;
    }

    if(this.filtroPesquisa.container != ''){
      filtros['container'] = "**:"+this.filtroPesquisa.container;
    }

    if(this.filtroPesquisa.conhecimento != ''){
      filtros['conhecimento'] = "**:"+this.filtroPesquisa.conhecimento;
    }

    this.fichasService.getPaginacao(pagina,this.itensPorPagina, ['mercadoria', 'cliente', 'status'], filtros)
      .subscribe(data => {
          this.fichas = data['Payload']['data'];
          this.totalItens = data['Payload']['total'];
          this.carregandoTabela = false;
        },
        error => {
          this.func.showErro(error.json());
          this.carregandoTabela = false;
        });
  }

  faturarContainer(container){
    let fichasService = this.fichasService;
    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaFaturarContainer')+container,
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){
        fichasService.faturarContainer(container)
          .subscribe(res => {
              self.getPage(self.paginaAtual);
            },
            error => {
              self.func.showErro(error.json());
            });
      });
  }

  modalPesquisaAvancada(){
    $('#modalPesquisaAvancada').modal('show');
  }

  pesquisaAvancada(){
    if (this.filtroPesquisa.data_de && !this.filtroPesquisa.data_ate) {
      this.filtroPesquisa.data_ate = new Date().toISOString().split('T')[0];
      this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    }
    this.salvaFiltro(this.filtroPesquisa);
    this.getPage(1);
    $('#modalPesquisaAvancada').modal('hide');
  }

  limpaPesquisaAvancada(){
    this.filtroPesquisa = {"mercadoria":"", "cliente":this.idCliente, "container":"", "data_de": "", "data_ate": "", "conhecimento": ""};
    this.limpaFiltroSalvo();
    this.formPesquisaAvancada.patchValue(this.filtroPesquisa);
    this.getPage(1);
  }

  changeContainer(e){
    this.filtroPesquisa.container = e.toUpperCase().replace(/_/g, '');
  }

  enviaParaCliente(id){
    let self = this;
    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaEnviarFichaCliente'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true
      },
      function(){
        self.fichasService.enviarFichaParaCliente(id)
          .subscribe(res => {
              //swal(this.func.traduzir('front.deletado'), this.func.traduzir('front.removidoComSucesso'), "success");
            },
            err => {
              self.func.showErro(err.json());
            });
      });
  }

  alteraStatus(id_ficha, id_status){
    let fichasService = this.fichasService;
    let self = this;

    swal({
        title: this.func.traduzir('front.voceTemCerteza'),
        text: this.func.traduzir('front.desejaAlterarStatus'),
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: 'btn-danger',
        confirmButtonText: this.func.traduzir('front.confirmar'),
        cancelButtonText: this.func.traduzir('front.cancelar'),
        closeOnConfirm: true,
      },
      function(){
        fichasService.setStatus(id_ficha, id_status)
          .subscribe(res => {
              swal(self.func.traduzir('front.sucesso'), self.func.traduzir('front.statusAlterado'), "success");
              self.getPage(self.paginaAtual);
            },
            error => {
              swal(self.func.traduzir('front.erro'), self.func.traduzir('front.statusNaoAlterado'), "error");
              self.func.showErro(error.json());
            });
      });
  }

  marcarTodos(event) {
    this.selecionarTodos = event.target.checked;
    this.fichas.forEach(ficha => {
      this.selecionados[ficha.id_ficha] = this.selecionarTodos;
    });
  }

  marcarItem(ficha, event) {
    this.selecionados[ficha.id_ficha] = event.target.checked;
    
    // Se desmarcar um item, desmarca o "selecionar todos"
    if (!event.target.checked) {
      this.selecionarTodos = false;
    } else {
      // Verifica se todos foram marcados individualmente
      let todosMarcados = true;
      for (let f of this.fichas) {
        if (!this.selecionados[f.id_ficha]) {
          todosMarcados = false;
          break;
        }
      }
      this.selecionarTodos = todosMarcados;
    }
  }

  modalFaturarEmMassa(){
    // Verifica se tem alguém selecionado
    let selecionadosIds = this.getSelecionadosIds();
    if(selecionadosIds.length == 0){
      swal(this.func.traduzir('front.erro'), this.func.traduzir('front.selecionePeloMenosUmItem'), "error");
      return;
    }

    this.faturar["data"] = new Date().toISOString().substr(0, 10);
    $('#modalFaturar').modal('show');
  }

  confirmarFaturarEmMassa(){
    this.carregandoBotaoFaturar = true;
    let selecionadosIds = this.getSelecionadosIds();

    this.faturasService.faturarFichasAvulsas(selecionadosIds, this.faturar["data"])
      .subscribe(res => {
          this.carregandoBotaoFaturar = false;
          swal(this.func.traduzir('front.sucesso'), this.func.traduzir('front.faturadoSucesso'), "success");
          this.getPage(this.paginaAtual);
          this.selecionados = {};
          this.selecionarTodos = false;
          $('#modalFaturar').modal('hide');
        },
        error => {
          this.carregandoBotaoFaturar = false;
          this.func.showErro(error.json());
        });
  }

  limpaFaturar(){
    this.faturar = { "data": "" };
    $('#modalFaturar').modal('hide');
  }

  private getSelecionadosIds(): string[] {
    let ids = [];
    for(let id in this.selecionados){
      if(this.selecionados[id]){
        ids.push(id);
      }
    }
    return ids;
  }

}



// WEBPACK FOOTER //
// ./src/app/financeiro/financeiro-preliminares-cliente.component.ts